import { createSelector } from 'reselect';
import { values, keys } from 'lodash';
import { utils } from './../helpers';
import { jobRelationshipsActionTypes } from './../actions/types';
import { cachedRequestByIdReducer } from './helpers';

const jobRelationships = cachedRequestByIdReducer(jobRelationshipsActionTypes, 'byId');
export default jobRelationships;

const getJobRelationshipsState = state => state.jobRelationships;
export const jobRelationshipsByIds = state => getJobRelationshipsState(state).byId;
export const getJobRelationshipsById = (state, id) =>
  jobRelationshipsByIds(state)[id];


export const getJobRelationships = createSelector(
  getJobRelationshipsState,
  (jobRelationshipState) => {
    if (jobRelationshipState && jobRelationshipState.byId) {
      return values(jobRelationshipState.byId);
    }
  }
);

export const groupJobRelationshipsByChildJobId = createSelector(
  getJobRelationships,
  (jobRelationships) => {
    if (jobRelationships) {
      return utils.propertyAccumulatorReducer(jobRelationships, 'child_job_id');
    }
  }
);

export const groupJobRelationshipsByParentJobId = createSelector(
  getJobRelationships,
  (jobRelationships) => {
    if (jobRelationships) {
      return utils.propertyAccumulatorReducer(jobRelationships, 'parent_job_id');
    }
  }
);

export const getJobRelationshipsChildJobIds = createSelector(
  groupJobRelationshipsByChildJobId,
  (groupJobRelationships) => {
    const childIds = keys(groupJobRelationships);
    return childIds; }
);

export const getJobRelationshipsByParentJobId = (state, id) =>
  groupJobRelationshipsByParentJobId(state)[id];


// WEBPACK FOOTER //
// src/reducers/jobRelationships.js